/** @format */

import React from 'react';

import { Avatar, Row, Col, Image } from 'antd';
import { FilePdfTwoTone } from '@ant-design/icons';
import { Comment } from '@ant-design/compatible';

import './style.css';

export default function ActionsDone(props) {
	let arrayObservation = props.product?.observation_reject_recipe || props.approveQf || [];

	return (
		<Row>
			<Col>
				<h1 className="ph-recipe-modal-ctiones-diponibility-done-container">
					{!!props.product ? 'Lista de observaciones:' : 'Aprobación bajo el criterio del Farmaceútico:'}
				</h1>
				{React.Children.toArray(
					arrayObservation.map((item) => (
						<Row style={{ width: 800, paddingTop: 20 }}>
							<Col>
								<Comment
									author={item.signature || item.qf_email}
									avatar={<Avatar src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png" alt="Han Solo" />}
									content={
										<div style={{ width: 450 }}>
											{props.reject ? (
												<>
													<p>
														<b>Motivo de rechazo:</b> {item.reason}
													</p>
													<p>
														<b>Mensaje interno:</b> {item.description}
													</p>
												</>
											) : (
												<>
													<p>
														<b>Criterio del Farmaceútico:</b> {item.observation}
													</p>
												</>
											)}
										</div>
									}
								/>
							</Col>
							<Col>
								{/.pdf/.test(item.recipe) ? (
									<a href={item.recipe} target="_blank" rel="noopener noreferrer">
										<FilePdfTwoTone style={{ fontSize: '75px' }} twoToneColor="#F40F02" />
									</a>
								) : (
									<Image width={200} src={item.recipe} />
								)}
							</Col>
						</Row>
					)),
				)}
			</Col>
		</Row>
	);
}
